import { ChangeDetectionStrategy, Component, Input, OnChanges, inject } from '@angular/core';
import { PICFLOW_STORYBLOK } from '../../../picflow-storyblok';
import { InternalRouteHelperService } from '../../../services/internal-route-helper.service';
import { SvgComponent } from '../../../shared/components/svg/svg.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { BlockStyle } from '../../interfaces/block-style';
import { StoryblokLinkUrlPipe } from '../../storyblok-link-url.pipe';
import { StoryblokLink } from '../../storyblok-types';
import { BlockWrapperComponent } from '../block-wrapper/block-wrapper.component';

type ButtonAlignment = 'left' | 'center' | 'right';

@Component({
  selector: 'app-storyblok-button',
  templateUrl: './storyblok-button.component.html',
  styleUrls: ['./storyblok-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BlockWrapperComponent, ButtonDirective, SvgComponent, StoryblokLinkUrlPipe],
})
export class StoryblokButtonComponent implements OnChanges {
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() style: BlockStyle[];

  @Input() link: StoryblokLink;
  @Input() text: string;
  @Input() analyticsName: string;
  @Input() alignment: ButtonAlignment = 'center';
  @Input() buttonSize: string;
  @Input() buttonSpacing: string;
  @Input() buttonStyle: string;
  /** CMS field pending delete — accept so ndcDynamicInputs does not warn (NG0303). Always pill via shape="round". */
  @Input() corners: string;
  @Input() textSize: string;
  @Input() bold: boolean;
  @Input() icon: string;
  @Input() iconPosition: 'left' | 'right' | 'bottom' = 'left';

  @Input() mobileAlignment: ButtonAlignment;
  @Input() tabletAlignment: ButtonAlignment;
  @Input() desktopAlignment: ButtonAlignment;

  private internalRouteHelperService = inject(InternalRouteHelperService);
  private storyblokService = inject(PICFLOW_STORYBLOK);

  /** Explicit CMS text, else linked story name (translated when available). */
  label = '';

  ngOnChanges(): void {
    if ((this.alignment as unknown) === true) {
      this.alignment = 'center';
    }

    if (!this.mobileAlignment) {
      this.mobileAlignment = this.alignment;
      if (!this.alignment) this.mobileAlignment = 'center';
    }
    if (!this.tabletAlignment) {
      this.tabletAlignment = this.alignment;
      if (!this.alignment) this.tabletAlignment = 'center';
    }
    if (!this.desktopAlignment) {
      this.desktopAlignment = this.alignment;
      if (!this.alignment) this.desktopAlignment = 'center';
    }

    this.label = this.text || this.storyblokService.getLinkName(this.link) || '';
  }

  onClick(event: Event) {
    return this.internalRouteHelperService.handleClick(event);
  }
}
